import React, { useMemo } from 'react';
import { Box } from '@material-ui/core';
import ResponsiveColumns from './ResponsiveColumns';

/**
 * Columns Container Component
 * Multi-column flex/grid layout
 * Supports 'columns', 'gap', 'padding', 'template', and 'ratio' props.
 */
const Columns = ({ children, layoutContractVersion = 1, columns = 2, gap = 16, template, ratio, padding = 0, style, ...props }) => {
  const gridTemplateColumns = useMemo(() => {
    // 1. Explicit template (e.g., "30% 70%") - has highest priority
    if (template) {
      return template;
    }

    // 2. Ratio (e.g., [3, 7] -> "3fr 7fr") - secondary priority
    // Handle both array and string (some editors might pass JSON string)
    if (ratio) {
      let ratioArray = Array.isArray(ratio) ? ratio : null;
      if (typeof ratio === 'string') {
        try { ratioArray = JSON.parse(ratio); } catch (_) { ratioArray = null; }
      }
      if (Array.isArray(ratioArray) && ratioArray.length > 0 && ratioArray.every((value) => Number(value) > 0)) {
        return ratioArray.map((value) => `minmax(0, ${Number(value)}fr)`).join(' ');
      }
    }

    // 3. Fallback to simple equal columns
    const cols = parseInt(columns, 10) || 2;
    return `repeat(${Math.max(1, cols)}, minmax(0, 1fr))`;
  }, [columns, template, ratio]);

  if (layoutContractVersion === 2) return (
    <ResponsiveColumns {...props} columns={columns} gap={gap}
      style={{ display: 'grid', gridTemplateColumns, gap: `${gap}px`, padding: `${padding}px`, width: '100%', minWidth: 0, minHeight: 0, boxSizing: 'border-box', ...style }}>
      {children}
    </ResponsiveColumns>
  );
  return (
    <Box
      display="grid"
      gridTemplateColumns={gridTemplateColumns}
      gridGap={`${gap}px`}
      padding={padding ? `${padding}px` : 0}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        ...style,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default Columns;
